import { PropertiesFilter, ResponseError } from "@shared/interfaces";
import { Property } from "@shared/interfaces/Property";

export enum PropertiesError {
  gePropertiesError = "gePropertiesError",
  gePropertyError = "gePropertyError",
}

export interface PropertySearchStateType {
  propertyList: Property[];
  property: Property | null;
  propertyCheckForAssign: {
    error: boolean;
    message: string;
    property?: Property | null;
  };
  selectedPropertiesIds: number[];
  total: number;
  filter: PropertiesFilter;
  errors: {
    [key in PropertiesError]: ResponseError | null;
  };
}
